module.exports = __webpack_public_path__ + "img/4f0f83919233c1c5050fa12e23ecef76.png";